const GROUP_HEADER_TYPE = {
  select: 'select',
  name: 'name',
  calory: 'calory',
  materials: 'materials',
  equivalent_materials: 'equivalent_materials',
};

export { GROUP_HEADER_TYPE };
